module.exports = __webpack_public_path__ + "img/weather06.e6e29d62.png";